import React, { Component } from 'react';

import moment from 'moment';
import { array, arrayOf, bool, func, oneOf, shape, string } from 'prop-types';

import { DatePickerMode } from '@philips-emr/tws-components-api';
import { Expression } from '@philips-emr/tws-constants';
import { date, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid } from '@philips-emr/tws-utils';

import { DatePickerContent, DatePickerEventsPanel, DatePickerTimeSpan } from '../components';
import { getDataGrid } from '../date-picker-util';

class DatePickerBasic extends Component {

  static propTypes = {
    clearExpression: expression,
    date: date,
    events: array,
    externalControls: bool,
    loading: bool,
    mode: oneOf(enumValues(DatePickerMode)),
    noAppointmentsExpression: expression,
    onArrowClick: func,
    onCellClick: func,
    onClear: func,
    onTitleClick: func,
    onToday: func,
    rangeEnabled: bool,
    ranges: arrayOf(shape({ startDate: string, endDate: string })),
    showClear: bool,
    showEvents: bool,
    todayExpression: expression,
    value: date,
  };

  static defaultProps = {
    clearExpression: Expression.CLEAR,
    date: moment.utc(),
    events: [],
    mode: DatePickerMode.MONTHLY,
    noAppointmentsExpression: Expression.NO_APPOINTMENTS,
    rangeEnabled: false,
    ranges: [],
    showEvents: true,
    todayExpression: Expression.TODAY,
    value: moment.utc(),
  };

  getClassName() {
    const { mode } = this.props;

    return classNames({
      'c-date-picker': true,
      [`c-date-picker--${mode}`]: isEnumValid(DatePickerMode, mode),
    });
  }

  renderEventsPanel = () => {
    const { noAppointmentsExpression, showEvents, value, events } = this.props;

    if (!showEvents) return null;

    return (
      <DatePickerEventsPanel data={events} date={value} noAppointmentsExpression={msg(noAppointmentsExpression)} />
    );
  };

  renderFooter() {
    const {
      clearExpression,
      externalControls,
      onClear,
      onToday,
      showClear,
      todayExpression,
    } = this.props;

    if (externalControls) {
      return null;
    }

    return (
      <div className="c-date-picker__footer">
        <span className="c-date-picker__today" onClick={onToday}>{msg(todayExpression)}</span>
        {showClear && <span className="c-date-picker-interval__action" onClick={onClear}>{msg(clearExpression)}</span>}
      </div>
    );
  }

  render() {
    const {
      date, events, mode, onCellClick,
      rangeEnabled, loading,
      value, onArrowClick, onTitleClick, ranges,
    } = this.props;

    const grid = getDataGrid({ mode, date, events });

    return (
      <div className={this.getClassName()}>
        <DatePickerTimeSpan mode={mode} date={date} onArrowClick={onArrowClick} onTitleClick={onTitleClick} />

        <DatePickerContent
          currentDate={value}
          data={grid}
          loading={loading}
          mode={mode}
          onClick={onCellClick}
          rangeEnabled={rangeEnabled}
          ranges={ranges}
        />

        {this.renderFooter()}
        {this.renderEventsPanel()}
      </div>
    );
  }
}

export default DatePickerBasic;
